export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6985.1c037d50.jpg";